// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__iScsR","footer":"ModalUpdate_footer__1YzC-"};